import axiosInstance from "services/AxiosInstance";
import { TAccountCreation } from "types/Account/AccountCreation";

export const createNewAccount = async (payLoad: TAccountCreation) => {
  const response = await axiosInstance.post(`accounts`, payLoad);
  return response.data;
};
